<div class="flex flex-col items-stretch gap-5">
    <div class="flex justify-center py-10" *ngIf="service.validationLoading()">
        <div class="spinner spinner-primary spinner-xl"></div>
    </div>

    <ng-container *ngIf="!service.validationLoading()">
        <div class="flex items-start justify-between">
            <div class="flex flex-col gap-2">
                <span class="font-bold" i18n>Validate data</span>
                <span class="text-sm" i18n>Check the imported data and complete the import.</span>
                <span *ngIf="service.validatedProductName() as productName" class="text-sm" data-testid="smartAssistantProductName" i18n
                    >Product: {{ productName }}</span
                >
            </div>
            <div class="flex items-center gap-2 shrink-0">
                <span class="text-sm" i18n>Show unchanged data</span>
                <input
                    type="checkbox"
                    class="toggle toggle-primary"
                    [ngModel]="showUnchanged()"
                    (ngModelChange)="showUnchanged.set($event)"
                />
            </div>
        </div>

        <app-feedback-banner
            *ngIf="service.hasErrors()"
            variant="warning"
            header="Attention"
            i18n-header
            message="Errors occurred during validation. Please review invalid data and correct before continue processing."
            i18n-message
        ></app-feedback-banner>

        <app-feedback-banner
            *ngIf="service.hasAmbiguousDateFormat()"
            data-testid="smartAssistantAmbiguousDateBanner"
            variant="warning"
            message="Some dates can be read in more than one way. Go back and choose the date format of the date column."
            i18n-message
        ></app-feedback-banner>

        <app-feedback-banner
            *ngIf="service.hasNoChanges()"
            data-testid="smartAssistantNoChangesBanner"
            variant="warning"
            message="The file contains no changes."
            i18n-message
        ></app-feedback-banner>

        <div class="w-full overflow-x-auto">
            <app-smart-assistant-validation-table [tableData]="tableData()"></app-smart-assistant-validation-table>
        </div>
    </ng-container>
</div>
